import constants, { ACCESS_TOKEN } from '../../../settings/shared/constants'
import axiosClient from '../../common';

function _constructHeader() {
    let jwtToken = localStorage.getItem(ACCESS_TOKEN);
    let headers = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + jwtToken
    }
    return headers;
}

function getProvisionerByService(serviceName) {
    return axiosClient({
        url: constants.api.cloud.getprovisionerByService + serviceName,
        method: 'GET',
        headers: _constructHeader(),
        data: ''
    });
}

function getZones(serviceName) {
    return axiosClient({
        url: constants.api.machineTypes.getInstanceRegion + "/" + serviceName,
        method: 'GET',
        headers: _constructHeader(),
        data: ''
    });
}



const ProvisionerService = {
    getProvisionerByService,
    getZones
}

export default ProvisionerService;